<template>
  <div class="relative lg:mr-8">
    <select
      v-model="languageselected"
      class="
        block
        appearance-none
        w-full
        bg-transparent
        border
        py-3
        px-4
        pr-10
        rounded
        leading-tight
        focus:outline-none
        cursor-pointer
      "
      :class="
        userType == 'user'
          ? ' text-black'
          : ' placeholder-menu-text-color border-menu-text-color'
      "
      id="grid-state"
      @change="onLanguageChange($event)"
    >
      <option v-for="(lang, i) in $page.props.languages" :key="i" :value="lang">
        <span v-if="lang == 'en'">English</span>
        <span v-if="lang == 'de'">Deutsch</span>
        <span v-if="lang == 'fr'">French</span>
      </option>
    </select>
    <div
      class="
        pointer-events-none
        absolute
        inset-y-0
        right-0
        flex
        items-center
        px-2
        placeholder-menu-text-color
        border-menu-text-color
      "
    >
      <svg
        class="fill-current h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userType: String,
    selectedLang: String,
  },
  data() {
    return {
      languageselected: this.selectedLang,
    };
  },
  methods: {
    onLanguageChange(event) {
      const data = {
        languageselected: event.target.value,
        isAdmin: this.$page.props.isAdminUser || this.$page.props.isSuperAdmin,
      };
      if (this.userType == "user") {
        this.$inertia.post("/updatelanguage", data, {
          onSuccess: () => location.reload(),
        });
      } else if (this.userType == "admin") {
        this.$inertia.post("/updateadminlanguage", data, {
          onSuccess: () => location.reload(),
        });
      }
    },
  },
};
</script>